import { Dropdown, DropdownChangeEvent, DropdownProps } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import React from 'react';
import { Control, Controller, ControllerRenderProps, RegisterOptions } from 'react-hook-form';

type RHFDropdownProps = {
    control: Control<any>;
    name: string;
    rules?: RegisterOptions;
    disabled?: boolean;
    placeholder?: string;
    inputProps?: DropdownProps;
    onChange?: (e: DropdownChangeEvent, field: ControllerRenderProps) => void;
};

export const RHFDropdown = ({ control, name, rules, disabled, placeholder, inputProps, onChange }: RHFDropdownProps) => {
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            disabled={disabled}
            render={({ field, fieldState }) => (
                <Dropdown
                    id={field.name}
                    {...field}
                    ref={undefined}
                    focusInputRef={field.ref}
                    className={classNames({ 'p-invalid': fieldState.invalid })}
                    placeholder={placeholder}
                    showClear={true}
                    {...inputProps}
                    {...(onChange && { onChange: (e: DropdownChangeEvent) => onChange(e, field) })}
                />
            )}
        />
    );
};
